<script>
  import options from './SchemaField.options'
  export default options
</script>

<template>
  <fieldset v-if="field.control === 'list' && expanded" class="kb-schema-markup__group">
    <legend class="kb-schema-markup__heading">{{ field.label }}</legend>

    <div v-for="(item, index) in field.items" :key="index" class="kb-schema-markup__list-item">
      <SchemaField :field="item" :depth="depth + 1" />
      <SchemaMarkupButton
        class="kb-schema-markup__remove"
        label="✕"
        @click="removeItem(field, index)"
      />
    </div>

    <SchemaMarkupButton label="Tilføj" @click="addItem(field)" />
  </fieldset>

  <fieldset v-else-if="field.control === 'fieldset' && expanded" class="kb-schema-markup__group">
    <legend v-if="field.label" class="kb-schema-markup__heading">{{ field.label }}</legend>
    <SchemaField v-for="(child, index) in field.fields" :key="index" :field="child" :depth="depth + 1" />
  </fieldset>

  <p
    v-else-if="field.control === 'list' || field.control === 'fieldset'"
    class="kb-schema-markup__truncated"
  >
    <span v-if="field.label" class="kb-schema-markup__truncated-label">{{ field.label }}</span>
    <span class="kb-schema-markup__truncated-value">{{ summary }}</span>
  </p>

  <SchemaLeaf v-else :field="field" />
</template>
